import { ApiEndpoints } from "../apiEndpoints";
import { requestApi } from "../apiService";
import type { CreditSessionResponse } from "../types/subscription";

const STRIPE_CHECKOUT_HOST = "checkout.stripe.com";

function assertStripeCreditUrl(url: string): void {
  let parsed: URL;
  try {
    parsed = new URL(url);
  } catch {
    throw new Error("Invalid Stripe redirect URL");
  }
  if (
    parsed.protocol !== "https:" ||
    parsed.hostname !== STRIPE_CHECKOUT_HOST
  ) {
    throw new Error(`Untrusted Stripe redirect URL: ${parsed.hostname}`);
  }
}

export const fetchCreditSession = async (
  sessionId: string,
): Promise<CreditSessionResponse> => {
  const response = await requestApi({
    url: `${ApiEndpoints.STRIPE_CREDIT_SESSION}/${sessionId}`,
    method: "GET",
  });
  return response.data as CreditSessionResponse;
};

export const createCreditCheckout = async (
  credits: number,
): Promise<string> => {
  const response = await requestApi({
    url: ApiEndpoints.STRIPE_CREDIT_CHECKOUT,
    method: "POST",
    data: { credits },
  });
  const url = response.data.url as string;
  assertStripeCreditUrl(url);
  return url;
};
